import React from "react"
import { Button, Typography } from "@material-ui/core"
import PropTypes from "prop-types"
import useStyles from "./signingCeremonyStyle"

export default function DefaultParagraph(props) {
  const classes = useStyles()
  const { messages, formName, format } = props
  return (
    <>
      <Typography paragraph>
        {format(messages.mainInfo, {
          formName: <strong>{formName}</strong>
        })}
      </Typography>
      <Typography paragraph>{format(messages.subInfo)}</Typography>
      <Button
        variant="outlined"
        color="secondary"
        className={classes.button}
        href="/documents"
      >
        {format(messages.button)}
      </Button>
    </>
  )
}
DefaultParagraph.propTypes = {
  messages: PropTypes.shape({
    title: PropTypes.any.isRequired,
    mainInfo: PropTypes.any.isRequired,
    subInfo: PropTypes.any.isRequired,
    button: PropTypes.any.isRequired
  }).isRequired,
  formName: PropTypes.string.isRequired,
  format: PropTypes.func.isRequired
}
